export type QueryKind = 'zip' | 'description' | 'invalid';

const DIGITS_ONLY = /^\d+$/;
const ZIP = /^\d{5}$/;
const MIN_DESCRIPTION_LENGTH = 3;

// Single source of truth for the digit/length rules used by both
// the form's smart input and the URL parser.
export function classifyQuery(q: string): QueryKind {
  const trimmed = q.trim();
  if (trimmed.length === 0) return 'invalid';
  if (DIGITS_ONLY.test(trimmed)) {
    return ZIP.test(trimmed) ? 'zip' : 'invalid';
  }
  return trimmed.length >= MIN_DESCRIPTION_LENGTH ? 'description' : 'invalid';
}
